import { render, staticRenderFns } from "./npl-xfxj.vue?vue&type=template&id=54c8567d&scoped=true"
import script from "./npl-xfxj.vue?vue&type=script&lang=js"
export * from "./npl-xfxj.vue?vue&type=script&lang=js"
import style0 from "./npl-xfxj.vue?vue&type=style&index=0&id=54c8567d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c8567d",
  null
  
)

export default component.exports